import * as authentication from "../../common/actions/authentication";
import * as delivery from "../actions/delivery.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        lastDelivery: {
            loading: false,
        },
        nextDelivery: {
            loading: false,
            version: 1,
        },
        dates: {
            upcomingDeliveryDates: []
        }
    });
};

/**
 * View reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case delivery.SET_LAST_DELIVERY:
        return state.merge({
            lastDelivery: action.delivery
        });
    case delivery.SET_LAST_DELIVERY_PRODUCT_IMAGE_URL:
        return state.merge({
            lastDelivery: {
                orderLines: Immutable(state.lastDelivery.orderLines).map(function(obj, index) {
                    return (index === action.index) ? {
                        ...obj,
                        product: {
                            ...obj.product,
                            imageUrl:action.imageUrl
                        }
                    } : obj;
                })
            }
        }, {
            deep: true
        });
    case delivery.LOADING_LAST_DELIVERY:
        return state.merge({
            lastDelivery: {
                loading: action.loading,
            }
        }, {
            deep: true
        });
    case delivery.LOADING_NEXT_DELIVERY:
        return state.merge({
            nextDelivery: {
                loading: action.loading,
            }
        }, {
            deep: true
        });
    case delivery.SET_UPCOMING_DELIVERY_DATES:
        return state.merge({
            dates: {
                deliveryDates: action.deliveryDates,
            }
        }, {
            deep: true
        });
    case delivery.SET_NEXT_DELIVERY:
        return state.merge({
            nextDelivery: {
                ...action.delivery,
                version: state.nextDelivery.version+1,
            }
        }, {
            deep: true
        });
    case delivery.SET_NEXT_DELIVERY_ORDER_PRODUCT_IMAGE_URL:
        return state.merge({
            nextDelivery: {
                orderLines: Immutable(state.nextDelivery.orderLines).map(function(obj, index) {
                    return (index === action.index) ? {
                        ...obj,
                        product: {
                            ...obj.product,
                            imageUrl:action.imageUrl
                        }
                    } : obj;
                })
            }
        }, {
            deep: true
        });
    case delivery.SET_NEXT_DELIVERY_UNCONFIRMED_ORDER_PRODUCT_IMAGE_URL:
        return state.merge({
            nextDelivery: {
                unConfirmedOrderLines: Immutable(state.nextDelivery.unConfirmedOrderLines).map(function(obj, index) {
                    return (index === action.index) ? {
                        ...obj,
                        product: {
                            ...obj.product,
                            imageUrl:action.imageUrl
                        }
                    } : obj;
                })
            }
        }, {
            deep: true
        });
    case delivery.RESET_LAST_DELIVERY:
        return state.setIn(["lastDelivery"], {loading: false});
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}